import { TemplatePage } from '../TemplatePage';

export const ManageNeighborhoodTemplates = () => {
  return <TemplatePage type="Neighborhood" title="Neighborhood" />;
};
